// @ts-nocheck
import React from 'react';

import LazyImage from 'crehana-ui/LazyImage';

import { MentorType } from '../../types';
import { css } from 'styled-components';

const Card: React.FC<MentorType> = ({
  avatarUrl,
  fullName,
  occupation,
  companyLogoUrl,
}) => {
  return (
    <div>
      <div
        css={css`
          padding-bottom: 152.1428%;
          ${({ theme }) => theme.breakpoints.up('sm')} {
            padding-bottom: 199.25%;
          }
          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
          }
        `}
        className="relative flex items-end rounded-5 overflow-hidden"
      >
        <LazyImage
          className="absolute h-full w-full top-0 left-0"
          imgClassName="object-cover"
          src={avatarUrl}
          alt="art"
        />
        <div
          css={css`
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              #070e27 34.31%
            );
            ${({ theme }) => theme.breakpoints.up('sm')} {
              background: linear-gradient(
                180deg,
                rgba(0, 0, 0, 0) 0%,
                #070e27 28.31%
              );
            }
          `}
          className="absolute bottom-0 flex flex-col items-center px-24 lg:px-40 z-3 mt-auto w-full justify-center pb-16 pt-32 sm:pt-0"
        >
          {/* Full name */}
          <p className="font-h2 text-white text-center mb-16 px-200 sm:hidden">
            {fullName}
          </p>
          <p className="font-h3 text-white text-center mb-16 px-200 hidden sm:block">
            {fullName}
          </p>
          <p className="font-subtitle4 text-gray-main text-center lg:h-36 lg:px-8 h-36 max-w-360 px-32">
            {occupation}
          </p>
          {companyLogoUrl ? (
            <LazyImage
              className="w-full block mt-24 h-40"
              src={companyLogoUrl}
              alt="company logo"
            />
          ) : (
            <div className="w-full h-40 -mb-40" />
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;
